import RevxFlexLayout from 'components/RevxFlexLayout';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import CommonQuantityPerBundle from '../common/CommonQuantityPerBundle';
import { useHideSvc } from '../hook/useHideSvc';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const DefaultSvc = (props: ConfigSvcProps) => {
  const hideSvc = useHideSvc(props);

  const hideSvcContainer = useHideSvcContainer(props);

  // const optionSvc = useMemo(() => {
  //   return {
  //     finish: jobOptionSvc.options?.find((option) => option.label === 'Finish'),
  //     other: jobOptionSvc.options?.filter(
  //       (option) => option.label !== 'Finish'
  //     ),
  //   };
  // }, [jobOptionSvc]);

  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />
          <div>
            <CommonJobSvcCotainer {...props}>
              <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
              <CommonJobSvcOption {...props} disabled={hideSvcContainer} />
              {/* <div style={{ marginRight: 23 }}>
          <div
            className="jobconfig-jobOption-content-label"
            style={{ marginBottom: 14 }}
            hidden={!optionSvc.finish || !optionSvc.finish.values}
          >
            Finish
          </div>
          <Form.Item name={[id, 'finish']} noStyle>
            <RevxRadio {...finishRadioProps} />
          </Form.Item>
        </div> */}
              {/* {optionSvc?.other?.map((svc) => (
              <div style={{ marginRight: 10 }}>
                <div
                  className="jobconfig-jobOption-content-label"
                  style={{ marginBottom: 14 }}
                >
                  {svc.label}
                </div>
                {svc.type === ServiceOptionTypeEnum.RADIO && (
                  <Form.Item name={[id, svc.label]} noStyle>
                    <Select className="jobconfig-jobOption-select"
                    getPopupContainer={(e) => {
                      return e as HTMLElement;
                    }}>
                      {svc.values?.map((value) => (
                        <Option value={value}>{value}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                {svc.type === ServiceOptionTypeEnum.INPUT && (
                  <Form.Item name={[id, svc.label]} noStyle>
                    <RevxInputNumber isInteger />
                  </Form.Item>
                )}
              </div>
            ))} */}
              <CommonQuantityPerBundle {...props} disabled={hideSvcContainer} />
              <CommonJobSvcInstructions
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
            </CommonJobSvcCotainer>
          </div>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default DefaultSvc;
